export const DISCLOSURE = "disclosure";
export const FORM_BACK = "form-back";
export const FORM_DISCLOSURE = "form-disclosure";
export const FORM_SUBMIT = "form-submit";
export const FORM_VALIDATE = "form-validate";
export const FORM_VIEW = "form-view";
